import { render, staticRenderFns } from "./LoansTable.vue?vue&type=template&id=52a7d5a8&scoped=true&"
import script from "./LoansTable.vue?vue&type=script&lang=ts&"
export * from "./LoansTable.vue?vue&type=script&lang=ts&"
import style0 from "./LoansTable.vue?vue&type=style&index=0&id=52a7d5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7d5a8",
  null
  
)

export default component.exports